import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerticalLayout1Module } from 'src/app/layout/vertical/layout-1/layout-1.module';
import { MaterialModule } from '../Shared/material.module';

@NgModule({
  imports: [VerticalLayout1Module, CommonModule, MaterialModule],
  exports: [VerticalLayout1Module, CommonModule, MaterialModule],
})
export class LayoutModule {}
